import { gql } from '@apollo/client';
import { getCurrentFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { getServerFrontendConfig } from '~/jobiqo/lib/frontendConfig';
import { isModuleEnabled } from '~/jobiqo/lib/config';

const getRuntimeFrontendConfig = (frontendConfig = null) => {
  if (frontendConfig) {
    return frontendConfig;
  }

  return typeof window === 'undefined'
    ? getServerFrontendConfig()
    : getCurrentFrontendConfig();
};

export const getJobTeaserFragment = (frontendConfig = null) => {
  const jobsConfig = getRuntimeFrontendConfig(frontendConfig).JOBS || {};
  const sourceEnabled = jobsConfig.ANALYTICS?.SOURCE_ENABLED;
  const salaryRangeFreeInputEnabled = isModuleEnabled(
    'jobiqo_job_salary_range_free_input',
  );
  const remoteJobsEnabled = jobsConfig.REMOTE_JOBS_FEATURE_ACTIVE;
  const seasonalJobsEnabled = jobsConfig.SEASONAL_JOBS_ENABLED;
  const jobSolrBackfill = jobsConfig.JOB_SOLR_BACKFILL;

  return gql`
  fragment JobTeaserFragment on Job {
    id
    title
    organization
    organizationProfile {
      id
      name
      url {
        path
      }
      urlNoPrefix
      logo(style: "job_squared_logo_medium") {
        url
        alt
      }
      workflowState {
        value
        label
      }
      isPremium
    }
    url {
      path
    }
    urlNoPrefix
    linkUrl
    logo(style: "job_squared_logo_medium") {
      url
    }
    expiration
    duration
    published
    formattedPublished
    formattedExpiration
    workflowState {
      value
      label
    }
    address
    occupationalField {
      tid
      label
    }
    salaryRange {
      tid
      label
    }
    absoluteUrl
    absoluteOrgUrl
    ${
      salaryRangeFreeInputEnabled
        ? `
      salaryRangeFree {
        minSalary
        maxSalary
        currencyCode
        salaryUnit
      }
    `
        : ''
    }
    isFeatured
    isHighlight
    isTopJob
    applicationWorkflow
    jobUpgrades
    ${isModuleEnabled('jobiqo_atnet') ? 'networkJobId' : ''}
    bookmarked
    sourcePortals
    ${sourceEnabled ? 'source' : ''}
    ${
      remoteJobsEnabled
        ? `
      remoteOptions {
        tid
        label
      }
    `
        : ' '
    }
    ${
      seasonalJobsEnabled
        ? `
      availabilityPeriod {
        startDate
        endDate
      }
    `
        : ''
    }
    ${jobSolrBackfill ? 'backfillid' : ''}
  }
`;
};

export default getJobTeaserFragment;
